import React, {useState} from "react"
import * as s from './css/premium-costi.module.css'
import { nl2br } from "../../../../utils/string-helpers"

const PremiumCosti = ({ project }) => {

    const [items, setItems] = useState([
        {
            title: 'App e conto',
            subitems: [
                { title: 'Registrazione', text: 'Gratuita' },
                { title: 'Imposta di Bollo', text: 'Gratuita' },
                { title: 'Ricarica Conto', text: 'Gratuita' },
                { title: 'Trasferimenti di denaro', text: 'Gratuiti' },
                { title: 'Bonifici', text: 'Gratuiti' },
            ],
            expanded: false,
        },
        {
            title: 'Carta',
            subitems: [
                { title: `Carta`, text: 'Gratuita' },
                { title: 'Ricarica carta', text: 'Gratuita' },
                { title: 'Spedizione carta', text: 'Gratuita' },
            ],
            expanded: false,
        },
        {
            title: 'Membership (in promozione fino al 30/06/2021)',
            subitems: [
                { title: `Membership annuale`, text: '60€ l\'anno (anzichè 85€)' },
                { title: `Extra Bonus`, text: '5€ di extra bonus se inviti un amico' },
                { title: `Extra Cashback `, text: '2€ di cashback sui pagamenti di bollo, bollettini, PagoPA (fino ad un massimo di 5)' },
                { title: 'Crowdfunding Unlimited', text: 'Incluso' },
                { title: 'Prelievi ATM Gratuiti in Italia e in UE', text: 'Inclusi' },
                { title: 'Spedizione rapida carta', text: 'Inclusa' },
                { title: 'Sconti esclusivi', text: 'Inclusi' },
            ],            
            expanded: false,
        }
    ]);

    return (
        <div className={`container-grid ${s.container}`}>
            <div className="col-span-4 desktop:col-span-6 desktop:col-start-4">
                <div className="text-center mx-4 desktop:mx-0">
                    <div className="leading-15 text-24 text-primary text-center font-bd">Quanto costa Tinaba Premium?</div>
                    <div className={`${s.containerData}`}>
                        {items.map( (d, indexD) => (
                            <div className={`${s.dataRow} flex flex-col`}>
                                <div aria-hidden="true" className={`flex flex-row`} onClick={() => { items[indexD].expanded = !d.expanded; setItems(oldArray => [...oldArray]);  }}>
                                    <div className={`flex flex-1 text-left items-center ${s.textItem}`}><span className="font-md text-3 text-primary leading-9">{d.title}</span></div>
                                    <div className={`flex text-right items-center font-md text-3 cursor-pointer	`} style={{userSelect:'none'}}>{ d.expanded ? '-' : '+' }</div>
                                </div>
                                {d.expanded && <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                                    {d.subitems.map(si => (
                                        <div className={`flex flex-row ${s.subitemContainer}`} style={{paddingTop:'12px', paddingBottom:'12px'}}>
                                            <div className={`flex flex-1 items-center`}><span className="font-md text-8 text-black text-left" style={{ lineHeight: '24px' }} dangerouslySetInnerHTML={{ __html: nl2br(si.title) }}></span></div>
                                            <div className={`flex flex-1 items-center justify-end`}><span className="font-md text-right text-8 text-black" style={{ lineHeight: '24px' }}>{si.text}</span></div>
                                        </div>
                                    ))}
                                </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default PremiumCosti